<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold"
        >“Your team flagged it last week and already has options on the table.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows your team is capable of making decisions without bottlenecking
      at you - a major marker of readiness.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack crews train for the captain to be off deck - because readiness
      is a system, not a person.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic">Could they sustain that for 30 days?</span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Document how they handled this situation - then use it to replicate
      decision ownership across other functions.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“A direct report mentions it in passing.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      There’s some awareness here - but it’s passive, not actionable. Your team
      clocked the moment, but didn’t connect it to mission or movement.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Alignment without urgency is like a submarine tracking a contact but never
      locking onto it - you’re aware, but not engaged.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Start treating competitor moves like sonar pings - they demand attention,
      discussion, and response.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Ask: <span class="italic"
        >What criteria turn a signal into an action?</span
      > Build your team’s reflex to surface, brief, and respond - before someone
      else makes the next move.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“A customer asks how you're responding.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a clear miss - the outside world is ahead of your internal
      systems.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a submarine, if you're reacting only after something breaks the hull,
      it's already too late. The best crews detect pressure before it becomes
      dangerous.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Install a horizon-scanning habit. Ask: <span class="italic"
        >Who’s watching, reporting, and decoding what competitors are doing -
        and how it affects our mission?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Build a habit of regular “external readiness checks” to reconnect your
      crew to the real threats.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold"
        >“You read about it online before anyone internally brought it up.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a mission-critical gap - the crew isn’t watching the water. Or
      worse, they’re seeing the threats and saying nothing.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack teams don’t wait to be told. They surface threats, communicate
      fast, and act with shared urgency. Silence isn’t safety - it’s danger.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Reset your early-warning system. Assign roles for competitive intelligence
      like sonar stations - not everyone watches everything, but someone always
      watches something.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Ask: <span class="italic"
        >What alerts should trigger action - and who’s responsible for sending
        them up the chain?</span
      >
    </p>
  {/if}
</div>
